<template>
  <core-sidebar
    sidebar-class="w-100 w-lg-25"
    id="mobile-navigation-sidebar"
    header-class="bg-portal-primary p-3"
    body-class="px-3 pt-3 d-flex flex-column"
    shadow
    backdrop
    lazy
  >
    <template #header="{ hide }">
      <b-row align-v="center" class="flex-grow-1">
        <b-col cols="auto" class="d-flex mr-auto">
          <b-button class="bg-transparent border-0 p-1" @click="hide()">
            <b-icon icon="x" font-scale="1.5"></b-icon>
          </b-button>
        </b-col>
      </b-row>
    </template>
    <template>
      <div class="mainnavi ps-0">
        <div class="mt-0 mb-0 ps-0 border-bottom position-relative" v-for="(item, index) in navigation" :key="index">
          <a v-b-toggle="'collapse-' + index" class="text-left d-block p-2 cursor-pointer text-portal-primary" role="tab">
            {{ item.title }}
            <b-icon icon="chevron-compact-up" class="position-absolute translate-middle-y" style="top: 20px; right: 5px"></b-icon>
          </a>
          <b-collapse :id="'collapse-' + index" class="mt-2" accordion="a-accordion" role="tabpanel">
            <ul v-if="item.child" class="pl-1">
              <li class="p-0" v-for="(sub1, sub1index) in item.child" :key="sub1index">
                <a class="p-0 d-block lh-base fs-6" target="_blank" :href="sub1.url" :title="sub1.title">
                  {{sub1.title}}
                </a>
              </li>
            </ul>
          </b-collapse>
        </div>
      </div>
    </template>
  </core-sidebar>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

@Component
export default class MobileNavigationSidebar extends Vue {
  @Prop({ default: [] }) private navigation!: any[];
}
</script>
<style scoped>
#mobile-navigation-sidebar .border-bottom {
  border-bottom-color: var(#949494) !important;
}
#mobile-navigation-sidebar a {
  color: var(--portal-primary);
}
#mobile-navigation-sidebar .collapsed svg {
  transform: translateY(-100%) rotate(180deg) translateY(-50%) !important;
}
#mobile-navigation-sidebar .not-collapsed {
  background: #fcf0d5;
}
</style>
